// @flow
import Experiment from 'app/common/react/components/experiments/Experiment';
import SeoExperiment from 'app/common/react/components/experiments/SeoExperiment';
import UnauthSeoExperiment from 'app/common/react/components/experiments/UnauthSeoExperiment';

// These are meant for testing purposes only, to be overridden in the Experiment
// mock files. Do not use in production.
const resetExperiments = () => {};
const setExpEnabled = (name: string, enabled: boolean) => {};
const setExpGroup = (name: string, group: string) => {};

export {
  Experiment,
  SeoExperiment,
  UnauthSeoExperiment,
  resetExperiments,
  setExpEnabled,
  setExpGroup,
};
